import React, { useState } from "react";
import logoschool from "../../assets/images/logosignup.png";
import logomain from "../../assets/images/logomain.png";

import googleImg from "../../assets/images/google.png";
import { useNavigate } from "react-router-dom";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import { verifySchoolSubscriptionBlocked } from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";

const Login = () => {
		const { signupData } = React.useContext(SchoolSignupContext);
	    const GOOGLE_AUTH_URL = process.env.REACT_APP_GOOGLE_AUTH_URL;

	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");
	const {
		showTrialExpiredModal,
		setShowTrialExpiredModal,
		handleTrialRenew,
		handleTrialCancel,
		cancelLoading,
	} = useTrialExpiredModal(signupData);

	const baseURL = process.env.REACT_APP_BASE_URL;

	const blockIfTrialExpired = async () => {
		const blocked = await verifySchoolSubscriptionBlocked(baseURL, {
			...signupData,
			schoolCode: signupData.schoolCode ?? signupData.verificationCode,
		});
		if (blocked) {
			setShowTrialExpiredModal(true);
			return true;
		}
		return false;
	};

	const handleGoogleLogin = async () => {
		if (await blockIfTrialExpired()) return;
		window.location.href = GOOGLE_AUTH_URL;
		// window.location.href = "https://scsbcbacknew.makemagento.com/auth/login";
		// window.location.href = "http://localhost:8000/auth/login";
		// http://localhost:8000/auth/login

	};


	const [emailError, setEmailError] = useState("");
	const handleEmailValidation = async () => {
		if (await blockIfTrialExpired()) return;

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!email) {
			setEmailError("Please enter your email.");
			return;
		}

		if (!emailRegex.test(email)) {
			setEmailError("Please enter a valid email address.");
			return;
		}

		navigate("/login-password", { state: { email } });
	};


	return (<>
		<TrialExpiredModal
			open={showTrialExpiredModal}
			onActivatePlan={handleTrialRenew}
			onCancelSubscription={handleTrialCancel}
			cancelLoading={cancelLoading}
		/>

		<div className="school-pages-inner">
			<div className="school-content-page">
				{/* <img src={logoschool}/>  */}
				{schoolType === 1 ? <img src={logomain} 
				alt="School Logo"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/school")}
				/> :		
				<img
					src={logoschool}
					alt="School Logo"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/school")}
				/>}

				<div className="schoo-outer">
					<div className="signup-outer-pagess">
						<h2>Log In</h2>
						<div className="email-inner" >
							<div className="input-container">
								<input type="email"
									placeholder=" "
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<label >Email address*</label>
							</div>
							{emailError && (
								<p className="error-message" style={{ color: "red" }}>
									{emailError}
								</p>
							)}
							<button className="continue-btn"
								// onClick={() => {navigate("/login-password", { state: { email } })}}
								onClick={handleEmailValidation}
							>
								Continue 
							</button>
						</div>


						<p className="login-account" >
							Don't have an account?
							<a
								href="/createsignup"
								//   href="/school"
								onClick={async (e) => {
									e.preventDefault();
									if (await blockIfTrialExpired()) return;
									navigate("/createsignup");
								}}
								style={{ cursor: 'pointer' }}

							>
								Sign Up
							</a>
						</p>

						<div className="or-inner" >
							<hr />
							<span >OR</span>
							<hr />
						</div>

						<div className="continue-inner-page">

							<button className="google-continue" onClick={handleGoogleLogin}>
								<img
									//   src="/google.png"
									src={googleImg}
									//   src="https://auth.openai.com/assets/google-logo-NePEveMl.svg" 
									alt="Google" />
								<span className="left-span">
									Continue with Google</span>
							</button>

							{/* <button className="google-continue"onClick={handleMicrosoftLogin}> 
			  <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="Microsoft" />
			 <span className="left-span">
			  Continue with Microsoft Account</span>
			</button> */}

						</div>

						<p className="term-part" >
							<a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
						</p>





					</div>

				</div>

			</div>

		</div>



	</>);

}
export default Login;